module.exports = {"pt-BR":{"components":{"paginator":{"first":"","prev":"","next":"","last":""}}}}